const CarretDownIcon = ({ stroke = false, className = '' }) => {
  const strokeColor = stroke ? stroke : 'currentColor';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.828"
      height="8.414"
      viewBox="0 0 14.828 8.414"
      className={className}
    >
      <path
        id="Path_203"
        data-name="Path 203"
        d="M2404.7,769.5l6,6,6-6"
        transform="translate(-2403.282 -768.086)"
        fill="none"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export default CarretDownIcon;
